import { render, staticRenderFns } from "./buyOrder.vue?vue&type=template&id=b63164ee&scoped=true&"
import script from "./buyOrder.vue?vue&type=script&lang=js&"
export * from "./buyOrder.vue?vue&type=script&lang=js&"
import style0 from "./buyOrder.vue?vue&type=style&index=0&id=b63164ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63164ee",
  null
  
)

export default component.exports